import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const Login = (store) => ({
  path: ROUTE.LOGIN,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'login',
    loadReducer: () => import('./LoginState'),
    loadComponent: () => import('./LoginContainer'),
  })
})

export default Login
